import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import App from './App';
import { zainstalujOdswiezaniePoBleduChunka } from '@/shared/lib/odswiezeniePoBleduChunka';
// B-523: the one client whose cache is dropped on every account change (logout included).
import { queryClient } from '@/shared/lib/queryClient';
import './index.css';

// B-485: karta otwarta przed wdrożeniem nie ma już plików ekranów, których nie zdążyła
// pobrać — przeładuj ją (z bezpiecznikiem przed pętlą) zamiast zostawiać biały ekran.
// PRZED pierwszym renderem: pierwsza trasa też jest leniwa.
zainstalujOdswiezaniePoBleduChunka(window);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster position="top-right" richColors closeButton duration={4000} />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
